export default "https://cdn-static.gokick.com/assets/f9e57853bbf9ca449046a7aa5fdd940e337957cb/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";